<template>
    <div class="root">
        <!-- 顶部导航 -->
        <header>
            <div class="close_btn">
                <img src="@/assets/imgs/close_btn.png" @click="onClickReturn" />
            </div>
            <div class="head_title"></div>
        </header>

        <div style="flex: 1; display: flex; flex-direction: column; overflow: auto">
            <!-- 查看列表 -->
            <main v-show="showPage == 'one'">
                <div class="main">
                    <h1 class="headTitle">{{ getLang('title') }}</h1>
                    <div style="justify-content: center;" class="menu_li" v-for="(it, i) in FirstList" :key="i" @click="onClickText(it.type, it[GAMELANG])">
                        {{ it[GAMELANG] }}
                        <img src="../assets/imgs/arrow.png" alt="" />
                    </div>
                </div>
            </main>

            <main v-show="showPage == 'two'">
                <div class="main">
                    <h1 class="headTitle">{{ title }}</h1>
                    <div class="menu_li" v-for="(it, i) in SecondList" :key="i" @click="onClickTwoText(it)">
                        {{ it[GAMELANG] }}
                        <img src="../assets/imgs/arrow.png" alt="" />
                    </div>
                </div>
            </main>

            <!-- 文章内容 -->
            <div v-show="showPage == 'details' || showPage == 'finish' || showPage == 'feedback'" class="Issues_wrap">
                <div class="Issues">
                    <div v-if="showPage == 'details'" style="height: 100%; flex: 1; display: flex; flex-direction: column; overflow: auto">
                        <h3>{{ title }}</h3>
                        <h4>{{ detailValue }}</h4>
                        <div class="article">
                            <div class="text_wrap" v-html="answerValue"></div>
                        </div>
                    </div>

                    <div v-else-if="showPage == 'finish'" class="finsh_wrap">
                        <img src="@/assets/imgs/finish.png" />
                        <div>{{ getLang('success') }}</div>
                    </div>

                    <div v-else-if="showPage == 'feedback'" class="feed_wrap">
                        <h3>{{ getLang('4') }}</h3>
                        <div class="input-select">
                            <el-select popper-class="selectStyle" :popper-append-to-body="false" v-model="typeValue" :placeholder="types[6][GAMELANG]">
                                <el-option v-for="(item, index) in types.slice(0, 6)" :key="index" :label="item[GAMELANG]" :value="item[GAMELANG]">{{ item[GAMELANG] }}</el-option>
                            </el-select>
                        </div>
                        <textarea v-model="message" :placeholder="getLang('question')"></textarea>
                        <p class="email-tip">{{ getLang('email') }}</p>
                        <input v-model="email" type="text" placeholder="yourmail@email.com" />
                    </div>

                    <div style="height: 2px; background: #5494c1; margin-top: 20px; border-radius: 20px"></div>
                    <div class="fot_btn" :class="{ fot_btn_D: showPage == 'feedback' && !isSend }" @click="returnGame">
                        {{ showPage == 'feedback' ? getLang('submit') : getLang('return') }}
                    </div>
                </div>
            </div>
        </div>

        <footer>
        </footer>

        <!-- 加载 -->
        <div id="loading" v-show="loading">
            <div class="loading-center">
                <span class="loading-icon"></span>
                <p>Loading...</p>
            </div>
        </div>
    </div>
</template>

<script>
import { myHTTP } from '@/utils/net'
import { lang } from '@/tool/faq.js'
import { types } from '@/tool/types.js'
import queryString from 'query-string'

const parsed = queryString.parse(location.search || '') || {}

let vh = window.innerHeight * 0.01
document.documentElement.style.setProperty('--vh', `${vh}px`)

export default {
    data() {
        return {
            types,
            typeValue: '',
            GAMELANG: 'en',
            isSend: false,
            loading: false,
            globalUserInfo: {},
            lang,
            email: '',
            message: '',
            showPage: 'one',
            FirstList: lang.filter(item => ["1", "2", "3", "4"].includes(item.type)),
            SecondList: [],
            title: '',
            detailValue: '',
            answerValue: '',
            detailObj: {}
        }
    },
    watch: {
        email: function (val, old) {
            let regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (regex.test(val) && this.message && this.typeValue) {
                this.isSend = true
            } else {
                this.isSend = false
            }
        },
        message: function (val, old) {
            let regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (val && regex.test(this.email) && this.typeValue) {
                this.isSend = true
            } else {
                this.isSend = false
            }
        },
        typeValue: function (val, old) {
            let regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (val && regex.test(this.email) && this.typeValue) {
                this.isSend = true
            } else {
                this.isSend = false
            }
        },
    },
    mounted() {
        location.href = 'uniwebview://get_player_info'
        window.get_player_info = this.getInfo

        this.initLANG()

        if (parsed.page == 'feedback') {
            this.showPage = 'feedback'
        }
    },
    methods: {
        initLANG() {
            let language = navigator.language.toLowerCase()
            if (parsed.gameLanguage) {
                language = parsed.gameLanguage
            }
            console.log(language, 'gameLanguage')
            if (language.startsWith('zh')) {
                if ('zh-cn' == language || 'zh-CN' == language || 'zh' == language) {
                    this.GAMELANG = 'zh-CN'
                } else {
                    this.GAMELANG = 'zh-TW'
                }
            } else if (language.startsWith('ja')) {
                this.GAMELANG = 'ja'
            } else if (language.startsWith('ko')) {
                this.GAMELANG = 'ko'
            } else if (language.startsWith('ru')) {
                this.GAMELANG = 'ru'
            } else if (language.startsWith('pt')) {
                this.GAMELANG = 'pt'
            } else if (language.startsWith('fr')) {
                this.GAMELANG = 'fr'
            } else if (language.startsWith('de')) {
                this.GAMELANG = 'de'
            } else if (language.startsWith('es')) {
                this.GAMELANG = 'es'
            } else if (language.startsWith('id')) {
                this.GAMELANG = 'id'
            } else if (language.startsWith('it')) {
                this.GAMELANG = 'it'
            } else if (language.startsWith('vi')) {
                this.GAMELANG = 'vi'
            } else if (language.startsWith('th')) {
                this.GAMELANG = 'th'
            } else {
                this.GAMELANG = 'en'
            }
        },
        getInfo(userInfo) {
            console.log(userInfo, 'userInfo')
            if (userInfo) {
                let globalUserInfo = {}
                globalUserInfo = decodeURIComponent(userInfo)
                this.globalUserInfo = JSON.parse(globalUserInfo)
                console.log(this.globalUserInfo, 'globalUserInfo')
            }
        },
        getLanguage(obj, val) {
            let LANG = this.GAMELANG
            let str = ''

            if (this.GAMELANG == 'zh-CN') {
                LANG = 'cn'
            } else {
                LANG = 'en'
            }
            str = obj[val + LANG]
            if(val == 'answer_'){
                let replacedStr  = str.replace(/\n/g, "<br>");
                return replacedStr
            }
            return str
        },
        getLang(val){
            let obj = this.lang.filter(item => item.type == val)[0];
            return obj[this.GAMELANG];
        },
        onClickContact() {
            this.showPage = 'feedback'
        },
        onClickReturn() {
            if (this.showPage == 'feedback') {
                this.showPage = 'one';
                this.email = '';
                this.message = '';
                return
            }
            if(this.showPage == 'two'){
                this.showPage = 'one';
                return
            }
            if(this.showPage == 'details'){
                this.showPage = 'two';
                return
            }
            if(this.showPage == 'finish'){
                this.returnGame();
                return
            }
            setTimeout(function () {
                location.href = 'uniwebview://close';
            }, 300)
        },
        onClickText(val, tit) {
            let str = val + '_';
            this.SecondList = this.lang.filter(item => item.type.indexOf(str) == 0 );
            this.title = tit;
            setTimeout(() => {
                if(val == 4){
                    this.showPage = 'feedback';
                    return
                }
                this.showPage = 'two';
            }, 300)
        },
        onClickTwoText(item){
            let str = 'answer_' + item.type;
            let obj = this.lang.filter(item => item.type == str)[0];
            this.detailValue = item[this.GAMELANG];
            this.answerValue = obj[this.GAMELANG];
            setTimeout(() => {
                this.showPage = 'details';
            }, 300)
        },
        returnGame() {
            if (!this.isSend && this.showPage == 'feedback') {
                return
            }
            if (this.showPage == 'feedback') {
                const postData = {
                    languages: navigator.languages,
                    userAgent: navigator.userAgent,
                    userInfo: this.globalUserInfo,
                    email: this.email,
                    type: this.typeValue,
                    message: this.message
                }
                console.log(this.email, this.message, postData)
                this.sendFeedback(postData)
            } else {
                setTimeout(function () {
                    location.href = 'uniwebview://close'
                }, 300)
            }
        },
        sendFeedback(postData) {
            this.loading = true

            myHTTP
                .post('/api/feedback', postData)
                .then(res => {
                    this.loading = false
                    console.log(res.data)
                    if (res.data.success) {
                        this.showPage = 'finish'
                    }
                })
                .catch(error => {
                    // 处理异步操作失败的情况
                    this.loading = false
                    console.error('异步操作失败，错误为：', error)
                })
        }
    }
}
</script>

<style scoped lang="less">
// 根
.root {
    display: flex;
    flex-direction: column;
    height: calc(var(--vh, 1vh) * 100);
    background: url('../assets/imgs/bg.png') no-repeat 100% 100%;
    background-size: 100% 100%;
    overflow: hidden;
}
// 顶部导航
header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: white;
    padding: 1vh;
    .close_btn {
        img {
            height: 5vh;
            transition: transform 0.3s ease; /* 设置缩放动画的过渡效果 */
        }
        img:active {
            transform: scale(0.85); /* 设置点击时的缩放比例 */
        }
    }
}

// 查看列表
main {
    flex: 1;
    font-size: 18px;
    padding: 0 3%;
    position: relative;
    overflow: auto;
    .headTitle{
        color: #fff;
        font-size: 2rem;
        margin-bottom: 3vh;
    }
    .main {
        height: 100%;
        overflow: auto;
        padding: 3vh 0 0;
        position: relative;
        .menu_li {
            width: 100%;
            padding: 12px 12% 12px 6%;
            color: #fff;
            font-weight: 800;
            margin-bottom: 10px;
            background: url('../assets/imgs/bg_blue.png') no-repeat 100% 100%;
            background-size: 100% 100%;
            white-space: normal;
            display: flex;
            align-items: center;
            text-align: left;
            position: relative;
            line-height: 1.2;
            transition: transform 0.3s ease; /* 设置缩放动画的过渡效果 */
            z-index: 2;
            transition: transform 0.2s ease-in-out; /* 添加平滑的缩放动画 */
            img {
                width: 32px;
                position: absolute;
                right: 4%;
                top: 44%;
                transform: translateY(-50%);
            }
        }
        .menu_li:active {
            transform: scale(0.95) !important; /* 设置点击时的缩放比例 */
        }
    }
    .main::-webkit-scrollbar {
        width: 2px; /* 设置滚动条宽度 */
    }

    .main::-webkit-scrollbar-thumb {
        background: #417aaa; /* 设置滚动条的颜色 */
        border-radius: 12px; /* 添加圆角 */
    }
}

.Issues_wrap {
    padding: 20px 14px 0;
    height: 100%;

    .Issues {
        height: 100%;
        background: url('../assets/imgs/Issues_bg.png') no-repeat 100% 100%;
        background-size: 100% 100%;
        padding: 4%;
        display: flex;
        flex-direction: column;
        position: relative;
        z-index: 2;
        h3 {
            font-size: 20px;
            color: white;
            text-shadow: -2px 0 #00446f, 0 2px #00446f, 2px 0 #00446f, 0 -2px #00446f;
        }
        h4 {
            width: 100%;
            font-size: 16px;
            padding: 4%;
            color: #ffffff;
            text-shadow: -2px 0 #00446f, 0 2px #00446f, 2px 0 #00446f, 0 -2px #00446f;
            margin: 10px 0;
            background: url('../assets/imgs/panel_bg.png') no-repeat 100% 100%;
            background-size: 100% 100%;
            white-space: normal;
            display: flex;
            align-items: center;
            text-align: left;
            position: relative;
            z-index: 2;
        }
        .article {
            flex: 1;
            width: 100%;
            font-size: 14px;
            padding: 4%;
            color: #a8e1ff;
            background: url('../assets/imgs/panel_bg2.png') no-repeat 100% 100%;
            background-size: 100% 100%;
            text-align: left;
            overflow: auto;
            position: relative;
            z-index: 2;
            .text_wrap {
                overflow: auto;
                position: absolute;
                top: 6%;
                left: 4%;
                right: 4%;
                bottom: 6%;
            }
        }

        .finsh_wrap {
            flex: 1;
            padding: 18px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            img {
                width: 50%;
                max-width: 300px;
            }
            div {
                font-size: 16px;
                color: white;
                text-shadow: -2px 0 #1a76ba, 0 2px #1a76ba, 2px 0 #1a76ba, 0 -2px #1a76ba;
            }
        }
        .feed_wrap {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            .email-tip {
                width: 100%;
                margin: 10px 0;
                color: #003360;
                font-size: 14px;
                text-align: left;
            }
            textarea,
            input {
                font-family: 'CookieRunBold' !important;
                display: block;
                padding: 10px;
                margin: 0px;
                width: 100%;
                font-size: 16px;
                border: none;
                background: #0c5687;
                color: #ffffff;
                border-radius: 10px;
            }

            textarea:focus,
            input:focus {
                outline: none;
            }

            textarea::placeholder,
            input::placeholder {
                color: #88bde7;
            }

            textarea {
                flex: 1;
                margin: 10px 0;
            }
        }
        .fot_btn {
            margin: 12px auto;
            display: inline-block;
            color: #fff;
            text-shadow: -1px 0 #1e7616, 0 1px #1e7616, 1px 0 #1e7616, 0 -1px #1e7616;
            font-size: 20px;
            background: url('../assets/imgs/BTN.png') no-repeat 100% 100%;
            background-size: 100% 100%;
            height: 60px;
            width: 80%;
            line-height: 60px;
            transition: transform 0.3s ease; /* 设置缩放动画的过渡效果 */
            position: relative;
            z-index: 2;
            padding: 0 14%;
        }
        .fot_btn:active {
            transform: scale(0.95); /* 设置点击时的缩放比例 */
        }
        .fot_btn_D {
            background: url('../assets/imgs/BTN_D.png') no-repeat 100% 100%;
            background-size: 100% 100%;
        }
        .fot_btn_D:active {
            transform: scale(0.95); /* 设置点击时的缩放比例 */
        }
    }
}

// 底部处理
footer {
    height: 120px;
    padding-top: 20px;
}

#loading {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 100;
}

.loading-center {
    text-align: center;
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);

    width: 100%;
}

.loading-center p {
    margin-top: 5px;
    margin-bottom: 0px;
    color: #d9ccb2;
}

.loading-center .loading-icon {
    display: inline-block;
    width: 64px;
    height: 64px;
    background: url('data:image/png;base64,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');
    background-size: cover;

    -webkit-animation: myRotate 10s linear infinite;
    animation: myRotate 1.5s linear infinite;
}

.input-select{
    position: relative;
    width: 100% !important;
    margin-top: 10px;
    /deep/.el-select{
        width: 100%;
        input {
            font-family: 'CookieRunBold' !important;
            display: block;
            padding: 10px;
            margin: 0px;
            width: 100%;
            font-size: 16px;
            background: #0c5687;
            border: 1px solid #0c5687;
            color: #ffffff;
            border-radius: 10px;
        }
        input:focus {
            outline: none;
            border: 1px solid #0c5687;
            border-color:#0c5687 !important;
        }
    
        input::placeholder {
            color: #88bde7;
            font-weight: 900;
        }
    }
}
.el-select-dropdown__item{
    font-weight: 900;
    color: #fff;
    text-align: left;
    background: #63abdf;    
}
.el-select-dropdown__item.selected{
    color: #fff;
    background: #0c5687;    
}

/deep/ .el-select-dropdown, .el-popper, .selectStyle{
    border: none !important;
    left: 0 !important;
}
/deep/ .el-select-dropdown__wrap.el-scrollbar__wrap {
    background: #63abdf !important; 
    left: 0 !important;
}
/deep/ .el-select .el-input .el-select__caret{
    font-size: 24px;
    color: #fff;
    font-weight: 900;
}
</style>


// WEBPACK FOOTER //
// src/components/FAQ.vue